import { defaultDemandWeights, DAY_WEIGHT_KEYS } from "./demandProfileDefaults";

const MONTH_KEYS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const GREEK_MONTHS = ["Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος", "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"];
// Proper short forms. Cutting the full Greek names at three letters gave
// «Ιού» for both June and July.
const GREEK_MONTHS_SHORT = ["Ιαν", "Φεβ", "Μαρ", "Απρ", "Μάι", "Ιουν", "Ιουλ", "Αυγ", "Σεπ", "Οκτ", "Νοε", "Δεκ"];

export function consumptionPeriods(inputType = "Monthly Consumption (kWh)", isGreek = false) {
  const size = inputType.startsWith("Annual") ? 12
    : /^(Quarterly|Tri-Monthly)/.test(inputType) ? 3
      : inputType.startsWith("Bi-Monthly") ? 2 : 1;
  const months = isGreek ? GREEK_MONTHS : MONTH_KEYS;
  const shortMonths = isGreek ? GREEK_MONTHS_SHORT : MONTH_KEYS.map((m) => m.slice(0, 3));
  return Array.from({ length: 12 / size }, (_, index) => {
    const first = index * size;
    const last = first + size - 1;
    return {
      key: size === 1 ? MONTH_KEYS[first] : `${MONTH_KEYS[first].slice(0, 3)}-${MONTH_KEYS[last].slice(0, 3)}`,
      label: size === 1 ? months[first] : `${months[first]} – ${months[last]}`,
      shortLabel: size === 1 ? shortMonths[first] : `${shortMonths[first]}–${shortMonths[last]}`,
    };
  });
}

export function consumptionPreviewRows(periods, monthly = {}) {
  return periods.map((period) => {
    const raw = monthly[period.key];
    const value = raw == null || String(raw).trim() === "" ? NaN : Number(raw);
    return { ...period, value: Number.isFinite(value) && value >= 0 ? value : null };
  });
}

// These are the input energy shares, before operating hours, holidays and
// base load. Do not present them as the engine's hourly consumption profile.
export function consumptionShareRows(weights, useCase) {
  let values = DAY_WEIGHT_KEYS.map((key) => Math.max(0, Number(weights?.[key]) || 0));
  if (!values.some((value) => value > 0)) {
    const defaults = defaultDemandWeights(useCase);
    values = DAY_WEIGHT_KEYS.map((key) => defaults[key]);
  }
  const total = values.reduce((sum, value) => sum + value, 0);
  return values.map((value, index) => ({
    label: ["00:00–06:00", "06:00–12:00", "12:00–18:00", "18:00–24:00"][index],
    value: value / total * 100,
  }));
}
